import { AddAnother } from '@/flows/marketplace/screens/add-another.js';
import { CustomerInfo } from '@/flows/marketplace/screens/customer-info.js';
import { EntryMarketplace } from '@/flows/marketplace/screens/entry.js';
import { Payment } from '@/flows/marketplace/screens/payment.js';
import { Tiers } from '@/flows/marketplace/screens/tiers.js';
import { step } from '@/flows/marketplace/state/step.js';

export function MarketplaceFlow() {
  switch (step.value) {
    case 'entry':
      return <EntryMarketplace />;
    case 'tiers':
      return <Tiers />;
    case 'payment':
      return <Payment />;
    case 'add-another':
      return <AddAnother />;
    case 'customer-info':
      return <CustomerInfo />;
  }
}
